import { render, staticRenderFns } from "./statisticIndex.vue?vue&type=template&id=f853b854&scoped=true"
import script from "./statisticIndex.vue?vue&type=script&lang=js"
export * from "./statisticIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f853b854",
  null
  
)

export default component.exports